export default __webpack_public_path__ + "img/fnGGEGzE.b0f5f2b7.svg";